// Contact.js - Contact & Support page
// Shows support email, FAQ section, and links to legal pages

import React from 'react';

const faqs = [
  {
    question: 'How do I book a grave visit?',
    answer:
      'Create a free account, then click "Book a Visit" on your dashboard. Fill in the details for your loved one and the cemetery, choose a service type and preferred date, and complete payment. We\'ll match you with a local caretaker in your area.',
  },
  {
    question: 'How are caretakers selected?',
    answer:
      'Every caretaker who joins Evermark Memorial completes a profile with their photo, bio, and service area. We review applications manually and rely on our customer rating system to maintain quality. Caretakers with consistently high ratings receive priority placement.',
  },
  {
    question: 'What services are available?',
    answer:
      'We currently offer four service tiers: Basic Visit & Photos ($59), Cleaning & Photos ($79), Flowers & Photos ($89), and Full Service which includes cleaning, flowers, and photos ($119). All services include a before-and-after photo report delivered to your dashboard.',
  },
  {
    question: 'How long does a visit take?',
    answer:
      'Most visits take between 30 minutes and 1 hour depending on the service type and the condition of the gravesite. Caretakers work at their own pace to ensure the visit is completed with care.',
  },
  {
    question: 'Can I cancel my booking?',
    answer:
      'Yes. You can cancel a pending or assigned booking directly from your dashboard before the visit has been completed. Open the booking card and click "Cancel Booking." Refunds are reviewed on a case-by-case basis and typically processed within 5–10 business days.',
  },
  {
    question: 'When do caretakers get paid?',
    answer:
      'Caretaker payouts via Stripe Connect are coming soon. In the meantime, all earnings are tracked on your Caretaker dashboard and will be paid out in full once direct deposit is enabled. No earnings will be lost.',
  },
  {
    question: 'What if I\'m not satisfied with the service?',
    answer:
      'If you feel the service was not completed as described, contact us at support@evermarkmemorial.com within 7 days of the completion date with details and photos. We\'ll review your case and work toward a fair resolution, which may include a partial or full refund.',
  },
  {
    question: 'How do I receive the visit photos?',
    answer:
      'Once the caretaker uploads their before and after photos, they appear automatically on your booking card in the dashboard. Click "View Photos" to see the full photo report. Photos are stored securely in the cloud.',
  },
  {
    question: 'Can I request a specific caretaker?',
    answer:
      'At this time, caretaker matching is based on service area. Caretakers in your area claim available jobs. If you\'ve had a great experience with a caretaker in the past, you can message them through the platform, and they may claim your next booking.',
  },
  {
    question: 'What areas does Evermark Memorial serve?',
    answer:
      'Evermark Memorial is currently expanding city by city. Coverage depends on which caretakers have signed up in your area. If no caretakers are available near your cemetery, your booking will remain open until one signs up. We\'re growing quickly — check back soon.',
  },
];

function Contact() {
  return (
    <div className="contact-page">
      <div className="contact-container">

        <a href="/" className="auth-logo">Evermark Memorial</a>

        <h1 className="legal-title">Contact &amp; Support</h1>
        <p className="legal-effective">We're here to help.</p>

        {/* Support email card */}
        <div className="contact-email-card">
          <h3>Get in Touch</h3>
          <p style={{ fontSize: '14px', color: '#888', marginBottom: '12px' }}>
            Have a question or issue? Send us an email and we'll respond within 1 business day.
          </p>
          <a href="mailto:support@evermarkmemorial.com" className="contact-email-link">
            support@evermarkmemorial.com
          </a>
        </div>

        {/* FAQ section */}
        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          {faqs.map((faq, i) => (
            <div key={i} className="faq-item">
              <p className="faq-question">{faq.question}</p>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </div>

        {/* Legal links at the bottom */}
        <div className="contact-legal-links">
          <a href="/terms">Terms of Service</a>
          <a href="/privacy">Privacy Policy</a>
        </div>

      </div>
    </div>
  );
}

export default Contact;
